// src/components/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';

function Footer({ variant = 'default' }) {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Ghost variant for Auth page
  if (variant === 'ghost') {
    return (
      <footer className="absolute bottom-0 left-0 w-full bg-transparent pointer-events-none">
        <div className="max-w-7xl mx-auto px-4 py-6 md:py-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 pointer-events-auto">
            <div className="text-xs text-white/20">
              © {currentYear} Epiphoric. All rights reserved.
            </div>
            <div className="flex flex-wrap gap-6 text-xs justify-center">
              <Link
                to="/how-it-works"
                onClick={scrollToTop}
                className="text-white/20 hover:text-white/60 transition-colors"
              >
                How It Works
              </Link>
              <Link
                to="/ai-tools"
                onClick={scrollToTop}
                className="text-white/20 hover:text-white/60 transition-colors"
              >
                AI tools
              </Link>
              <Link
                to="/support"
                onClick={scrollToTop}
                className="text-white/20 hover:text-white/60 transition-colors"
              >
                Support
              </Link>
              <Link
                to="/privacy"
                onClick={scrollToTop}
                className="text-white/20 hover:text-white/60 transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                onClick={scrollToTop}
                className="text-white/20 hover:text-white/60 transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  // Default variant for other pages
  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-sm text-gray-600 dark:text-gray-400">
            © {currentYear} Epiphoric. All rights reserved.
          </div>
          <div className="flex flex-wrap gap-6 text-sm justify-center">
            <Link
              to="/how-it-works"
              onClick={scrollToTop}
              className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors"
            >
              How It Works
            </Link>
            <Link
              to="/ai-tools"
              onClick={scrollToTop}
              className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors"
            >
              AI tools
            </Link>
            <Link
              to="/support"
              onClick={scrollToTop}
              className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors"
            >
              Support
            </Link>
            <Link
              to="/privacy"
              onClick={scrollToTop}
              className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms"
              onClick={scrollToTop}
              className="text-gray-600 dark:text-gray-400 hover:text-primary dark:hover:text-primary transition-colors"
            >
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

